/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - CSS
 */
import './styles/Navbar.css'

/**
 *     Import
 *     - Components
 */
import { NavLink } from 'react-router-dom'
import { CustomNavLink } from './components/CustomNavLink'
import Notifications from '../../../containers/common/Notifications/Notifications'
import Search from '../Search/Search'

/**
 *     Import
 *     - Images
 */
import { LogoImage } from '../../../images/logo/Logo'
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'
import { UserIcon } from '../../../images/icons/User/User'
import { DefaultPicture } from '../../../images/icons/DefaultPicture/DefaultPicture'
import { CogIcon } from '../../../images/icons/Cog/Cog'
import { ExitIcon } from '../../../images/icons/Exit/Exit'
import { ManageIcon } from '../../../images/icons/Manage/Manage'
import { NavBarIcon } from '../../../images/icons/NavBar/NavBar'
import { CloseIcon } from '../../../images/icons/Close/Close'

export default class Navbar extends React.Component<any, any> {

    wrapperRef: any

    constructor(props: any) {
        super(props)
        this.state = {
            menuActive: false,
        }
    }

    componentWillMount() {
        this.props.fetchUserDetail()
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    /**
     * Toggle menu state
     */
    toggleMenu = () => this.setState({ menuActive: !this.state.menuActive })

    /**
     * Set the wrapper ref for handling outside click
     */
    setWrapperRef = (node: any) => this.wrapperRef = node

    /**
     * Close Menu when clicking outside
     */
    handleClickOutside = (event: any) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.menuActive) {
            this.toggleMenu()
        }
    }

    render() {
        /**
         * Get menuActive state and set it as 'active' if = true
         * @type {string}
         */
        let menuActive = (this.state.menuActive) ? 'active' : ''
        let userDetail: any = undefined

        if (this.props.userDetail.done) {
            userDetail = this.props.userDetail.userDetail
        }

        let urlLastSplit = window.location.href.split('/')
        return (
            <div className="navbar" ref={this.setWrapperRef}>

                <div className="navbar__brand bar">
                    <div className="navbar__container">

                        <div className="bar__logo">
                            <LogoImage />
                        </div>

                        <div className="bar__user userMenu">

                            <div className={`userMenu__photo ${menuActive}`} onClick={this.toggleMenu}>
                                <div className="userMenu__photo__container">
                                    {(userDetail) ?
                                        <img src={userDetail.user.avatar} alt="Profile photo" /> :
                                        <DefaultPicture />}

                                </div>
                            </div>

                            <div className={`userMenu__dropdown ${menuActive}`}>
                                <div className={`userMenu__dropdown__button  ${menuActive}`} onClick={this.toggleMenu}>
                                    <DropdownArrowIcon />
                                </div>
                                <div className={`userMenu__dropdown__container ${menuActive}`}>
                                    <div>
                                        <div className="userMenu__details">
                                            <div className="userMenu__details__name">
                                                {(userDetail) ? userDetail.user.firstName : ''}
                                            </div>
                                            <div className="userMenu__details__company">
                                                {(userDetail) ? userDetail.agent.name : ''}
                                            </div>
                                            <div className="userMenu__details__icon">
                                                <UserIcon />
                                            </div>
                                        </div>
                                        <div className="userMenu__items" onClick={this.toggleMenu}>
                                            <NavLink to="/user/account">
                                                <div className="userMenu__item">
                                                    <span>My account</span>
                                                    <span className="icon"><CogIcon /></span>
                                                </div>
                                            </NavLink>
                                            <NavLink to="/logout">
                                                <div className="userMenu__item">
                                                    <span>Logout</span>
                                                    <span className="icon"><ExitIcon /></span>
                                                </div>
                                            </NavLink>
                                            <div className={`${(this.props.userSession.agentAdmin) ? '' : 'disabled'}`}>
                                                <NavLink to="/agent-admin/manage-agency">
                                                    <div className="userMenu__admin" onClick={this.toggleMenu}>
                                                        <div className="userMenu__item userMenu__item--admin">
                                                            <span>Manage Agency</span>
                                                            <span className="icon"><ManageIcon /></span>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`bar__getquote ${(urlLastSplit.indexOf('quote') !== -1) ? 'disabled' : ''}`}>
                            {
                                (urlLastSplit.indexOf('quote') === -1) ?
                                    <Link to={'/quote/new/step00'}>
                                        <span>Get a Quote</span>
                                    </Link> :
                                    <span>Get a Quote</span>
                            }

                        </div>
                    </div>
                </div>

                <div className="navbar__menu bar bar__navigation_buttons">
                    {/* className="navbar__container" DISABLED */}
                    <div className="navbar__group">
                        <div className="navbar__container ofhidden">
                            <div
                                className={`bar__menuItems ${
                                    (this.props.navbar.navbar === 0 || this.props.navbar.navbar === null) ?
                                        '' :
                                        'inactive'}`}
                            >
                                <CustomNavLink dashboard={true} to="/dashboard">dashboard</CustomNavLink>
                                <CustomNavLink to="/clients">your clients</CustomNavLink>
                                <CustomNavLink to="/renewals">renewals</CustomNavLink>
                                <CustomNavLink to="/accounts">accounts</CustomNavLink>
                            </div>
                            <div className={`bar__menuItems ${(this.props.navbar.navbar === 1) ? '' : 'inactive'}`}>
                                <div className="bar__menuItems__icon">
                                    <NavBarIcon />
                                </div>
                                <CustomNavLink
                                    to="/dashboard"
                                    className="bar__menuItems__icon__text"
                                >
                                    Return to dashboard
                                </CustomNavLink>
                            </div>
                        </div>
                        <div
                            className={`bar__actions ${
                                (this.props.navbar.navbar === 0 || this.props.navbar.navbar === null) ?
                                    '' :
                                    'inactive'}`}
                        >
                            <Link
                                to={`${(urlLastSplit.indexOf('search') !== -1) ? '/dashboard' : '/search'}`}
                            >
                                <div
                                    className=
                                    {
                                        `bar__actions__search
                                ${(urlLastSplit.indexOf('search') !== -1) ?
                                            'active' :
                                            ''
                                        }`
                                    }
                                >
                                    {(urlLastSplit.indexOf('search') !== -1) ?
                                        <div>
                                            <CloseIcon />
                                        </div> :
                                        <div>
                                            <Search />
                                        </div>}
                                </div>
                            </Link>
                            <div className="bar__actions__notifications">
                                <Notifications />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Navbar/Navbar.tsx